<template>
  <section class="task-wrap" :style="dBHeight">
    <div class="tab_ty1">
      <ul class="tab-menu">
        <li
          v-for="(tab, index) in tabs"
          v-bind:class="{ active: currentTab === index }"
          :key="'tab_' + index"
        >
          <button type="button" @click="changeTab(index)">
            {{ tab }}
          </button>
        </li>
      </ul>
      <div class="tab-content">
        <!-- 이력 Tab -->
        <div v-show="currentTab2 == 0">
          <div class="tab_ty2">
            <ul class="tab-menu">
              <li
                v-for="(tab, index) in tabs2"
                v-bind:class="{ active: currentTab2 === index }"
                :key="'tabs2_' + index"
              >
                <button type="button" @click="changeTab2(index)">
                  {{ tab }}
                </button>
              </li>
            </ul>
            <div class="tab-content">
              <!-- 파일다운로드이력 Tab -->
              <div>
                <FileDownloadList ref="fileDownloadList"></FileDownloadList>
              </div>
            </div>
          </div>
        </div>
        <!-- 파일복사이력 Tab -->
        <div v-show="currentTab2 == 1">
          <div class="tab_ty2">
            <div class="tab-content">
              <div>
                <FileCopyList ref="fileCopyList"></FileCopyList>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 로그인이력 Tab -->
      <div v-show="currentTab2 == 2">
        <div class="tab_ty2">
          <div class="tab-content">
            <div>
              <LoginList ref="loginList"></LoginList>
            </div>
          </div>
        </div>
      </div>
      <!-- 파일DLP차단이력 Tab -->
      <div v-show="currentTab2 == 3">
        <div class="tab_ty2">
          <div class="tab-content">
            <div>
              <FileDlpBlockList ref="fileDlpBlockList"></FileDlpBlockList>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import FileDownloadList from "./tab/history/FileDownloadList";
import FileCopyList from "./tab/history/FileCopyList";
import LoginList from "./tab/history/LoginList";
import FileDlpBlockList from "./tab/history/FileDlpBlockList";

export default {
  components: {
    FileDownloadList,
    FileCopyList,
    LoginList,
    FileDlpBlockList,
  },
  data() {
    return {
      userId: "",
      userInfo: null,
      currentTab: -1,
      currentTab2: -1,
      tabs: ["테스트"],
      tabs2: [
        this.$i18nUtil.trans("message.AuditSubTab.007","파일다운로드이력"),
        this.$i18nUtil.trans("message.AuditSubTab.008","파일복사이력"),
        this.$i18nUtil.trans("message.AuditSubTab.009","로그인이력"),
        this.$i18nUtil.trans("message.AuditSubTab.006","개인정보차단목록"),
      ],
      dBHeight: {
        "min-height": window.innerHeight - 151 + "px",
      },
    };
  },
  mounted() {
    this.changeTab(0);
  },
  methods: {
    changeTab(index) {
      if (this.currentTab != index) {
        this.currentTab = index;
        this.changeTab2(0);
      }
    },
    changeTab2(index) {
      this.currentTab2 = index;
      if (index === 0) {
        //파일다운로드이력
        this.$refs.fileDownloadList.getFileDownloadList();
      } else if (index === 1) {
        //파일복사이력
        this.$refs.fileCopyList.getFileCopyList();
      } else if (index === 2) {
        //로그인이력
        this.$refs.loginList.getLoginList();
      } else if (index === 3) {
        //파일DLP차단이력
        this.$refs.fileDlpBlockList.getFileDlpBlockList();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/Audit.vue